exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_profiles_2oA-My7ppfO-4bVMXBo_b7 {\n  width: 100%;\n}\n\n.IA_profiles_2oA-My7ppfO-4bVMXBo_b7 h1 {\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_profiles": "IA_profiles_2oA-My7ppfO-4bVMXBo_b7"
};